import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../components/Common/Loader";
import EmailTemplatePreview from "../../components/Email/EmailTemplatePreview";
import axiosInstance from "../../utils/api";
import { BiLaptop, BiMobile, BiCode, BiArrowBack } from "react-icons/bi";
import ReactDOMServer from "react-dom/server";
import { ToastContainer, toast } from 'react-toastify';
const PreviewEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [previewData, setPreviewData] = useState(null);
  const [styleSettings, setStyleSettings] = useState({
    primaryColor: "#333333",
    secondaryColor: "#a1894c",
    backgroundColor: "#ffffff",
    fontFamily: "helvetica, 'helvetica neue', arial, verdana, sans-serif"
  });
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState(location.state?.mode || "desktop");
  console.log("PreviewEmail initial mode:", location.state?.mode, "viewMode state:", viewMode);
  const [showHtml, setShowHtml] = useState(false);
  const [domHtml, setDomHtml] = useState("");
  const previewRef = useRef(null);
  const [templateImages, setTemplateImages] = useState([]);
  const templateName = location.state?.sku?.replace(/_/g, " ")?.trim()?.replace(/\s+/g, " ") || "";
  const templateId = location.state?.templateId || "";
  useEffect(() => {
    const draftId = localStorage.getItem("last_saved_draft_id");
    if (!draftId) {
      setLoading(false);
      return;
    }

    const fetchDraft = async () => {
      try {
        const response = await axiosInstance.get(`/api/v1/email_templates/${draftId}`);
        const draft = response.data;
        if (draft && draft.foray_response?.data) {
          const data = draft.foray_response.data;
          setPreviewData(data);
          setTemplateImages(draft?.attachments.map(x => ({ component_name: x.name, link: x?.image?.url })));

          if (draft.foray_response.styleSettings) {
            const styles = {
              primaryColor: draft.foray_response.styleSettings.primaryColor || "#333333",
              secondaryColor: draft.foray_response.styleSettings.secondaryColor || "#a1894c",
              backgroundColor: draft.foray_response.styleSettings.backgroundColor || "#ffffff",
              fontFamily: draft.foray_response.styleSettings.fontFamily || "helvetica, 'helvetica neue', arial, verdana, sans-serif"
            };
            setStyleSettings(styles);
          }
        } else {
          setPreviewData([]);
        }
      } catch (error) {
        console.error("Failed to fetch draft:", error);
        setPreviewData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDraft();
  }, []);

  // Update DOM HTML when needed
  useEffect(() => {
    if (showHtml && previewRef.current) {
      // Get the inner content
      const content = previewRef.current.innerHTML;
      
      // Create a complete HTML document matching the ESP format
      const completeHtml = `<!DOCTYPE html>
  <html lang="en">
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <title>Email Template</title>
    <style type="text/css">
   
    </style>
  </head>
  <body>
    
        ${content}
    
  </body>
  </html>`;
      
      setDomHtml(completeHtml);
    }
  }, [showHtml, previewData, styleSettings, viewMode]);

  // Use ReactDOMServer to get a cleaner copy for the clipboard
  const copyHtmlToClipboard = () => {
    try {
      if (!previewRef.current) {
        toast.error("Preview not ready!");
        return;
      }
      const content = previewRef.current.innerHTML;
      const completeHtml = `<!DOCTYPE html>
  <html lang="en">
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <title>Email Template</title>
    <style type="text/css">
   
    </style>
  </head>
  <body>
    
        ${content}
    
  </body>
  </html>`;
      
      navigator.clipboard.writeText(completeHtml)
        .then(() => {
          toast.success("HTML copied to clipboard!");
        })
        .catch(err => {
          toast.error("Failed to copy HTML: ", err);
        });
    } catch (err) {
      toast.error("Failed to copy HTML: ", err);
    }
  };
  // push to brevo function
  const pushToBrevo = async () => {
    try {
      if (!previewRef.current) {
        toast.error("Preview not ready!");
        return;
      }
      const content = previewRef.current.innerHTML;
      const completeHtml = `<!DOCTYPE html>
  <html lang="en">
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <title>Email Template</title>
    <style type="text/css">
   
    </style>
  </head>
  <body>
    
        ${content}
    
  </body>
  </html>`;
  
  const draftId = localStorage.getItem("last_saved_draft_id");
  const campaignId = localStorage.getItem("campaign_id");
    
  if (!draftId) {
    toast.error('No draft found! Please save as draft first.');
    return;
  }
  
  const formData = new FormData();
  setLoading(true);
  formData.append('html_content', completeHtml);
  formData.append('name', templateName || "Email Template");
  formData.append('subject', 'Welcome to Our Newsletter');
  formData.append('tag', 'Email Templates');
  formData.append('email_template_id', draftId);
  // If we have a campaign_id, append it to update the existing template
  if (campaignId) {
    formData.append('campaign_id', campaignId);
  }
  
  const token = localStorage.getItem('token');
  
  const response = await axiosInstance.post(
    '/api/v1/email_templates/create_template',
    formData,
    {
      headers: {
        'Authorization': token,
      }
    }
  );

  // Store the campaign_id if it's a new template
  if (response.data && response.data.campaign_id) {
    localStorage.setItem('campaign_id', response.data.campaign_id);
  } 
    setLoading(false);
    toast.success(response.data.message);
  } catch (error) {
    setLoading(false);
    console.error('Push to Brevo failed:', error);
    toast.error(error.response.data.message);
  }
  };

  if (loading) {
    return(
     <div className="loader-container">
     <Loader />
     </div>
    );
  }

  if (!previewData || previewData.length === 0) {
    return (
      <div className="email-template-empty-message" style={{ padding: '40px 20px', textAlign: 'center' }}>
        <h4>No content to preview</h4>
        <p>Add some sections and save as draft to see the preview.</p>
      </div>
    );
  }

  return (
    

    <div className="email-template-preview-container">
   <div className="preview-header">
   <div className="preview-header-back" onClick={() => navigate(-1)}>
                 &lt; Back to edit
             </div>
             <div className="device-icons d-flex border border-black rounded justify-content-between align-items-center">
       
        <div className="d-flex justify-content-center align-items-center">
            <button className={`btn ${viewMode === "desktop" ? "active" : ""}`} onClick={() => setViewMode("desktop")}>
                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 17.722c.595-.347 1-.985 1-1.722V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v11c0 .736.405 1.375 1 1.722V18H2v2h20v-2h-2v-.278zM5 16V5h14l.002 11H5z"></path>
                </svg>
            </button>
            |
            <button className={`btn ${viewMode === "mobile" ? "active" : ""}`} onClick={() => setViewMode("mobile")}>    
                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 2H7c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM7 16.999V5h10l.002 11.999H7z"></path>
                </svg>
            </button>
        </div>
    </div>
    <div className="btns d-flex justify-content-end gap-3">
        <div><button className="btn bgprimary rounded"   onClick={() => setShowHtml(!showHtml)}>{showHtml ? "Hide HTML" : "Show HTML"}</button></div>
        <div><button className="btn btn-dark rounded"  onClick={pushToBrevo}>Push to ESP</button></div>
    </div>

   </div>

       
      <div className="d-flex gap-4 align-items-center justify-content-between">
        <div>
  
        </div>
      
    
   
</div>
      {/* HTML code view */}
      {showHtml && (
        <div style={{
          padding: '20px',
          backgroundColor: '#2d2d2d',
          position: 'relative',
          maxHeight: '400px',
          overflow: 'auto'
        }}>
          <button 
            onClick={copyHtmlToClipboard}
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              background: '#555',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '6px 12px',
              cursor: 'pointer'
            }}
          >
            Copy HTML
          </button>
          <pre style={{ 
            color: '#e6e6e6', 
            margin: 0,
            fontFamily: 'monospace',
            fontSize: '12px',
            padding: '10px',
            whiteSpace: 'pre-wrap'
          }}>
            {domHtml}
          </pre>
        </div>
      )}

      {/* Email preview */}
      <div className={`email-preview-frame ${viewMode}`} style={{
        padding: '20px',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#f8f8f8',
        minHeight: showHtml ? 'calc(100vh - 480px)' : 'calc(100vh - 80px)'
      }}>
        <div 
          ref={previewRef}
          style={{
            width: viewMode === "mobile" ? "375px" : "100%",
            maxWidth: viewMode === "desktop" ? "1000px" : "375px",
            border: viewMode === "mobile" ? "12px solid #333" : "none",
            borderRadius: viewMode === "mobile" ? "30px" : "0",
            height: viewMode === "mobile" ? "667px" : "auto",
            overflow: "auto",
            //backgroundColor: styleSettings.backgroundColor || "white",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            transition: "all 0.3s ease"
          }}>
          <EmailTemplatePreview
            styleSettings={styleSettings}
            sectionsData={previewData}
            viewMode={viewMode}
            templateImages={templateImages}
          />
        </div>
      </div>
    </div>
  );
};

export default PreviewEmail;